/**
 * Release Management API client.
 */
import { getIdToken } from '../contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../config/api';

async function authedFetch(endpoint, options = {}) {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Not authenticated. Please log in.');

  const response = await fetch(buildApiUrl(endpoint), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(idToken),
      ...(options.headers || {}),
    },
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.message || body.error || `Request failed: ${response.statusText}`);
    error.payload = body;
    throw error;
  }
  return body;
}

/** Product list and firmware variant allowlist, for the form. */
export const fetchReleaseProducts = () => authedFetch('/releases/products');

/** Releases of one product (or all), newest first. */
export const fetchReleases = async (product) => {
  const qs = product ? `?product=${encodeURIComponent(product)}` : '';
  return (await authedFetch(`/releases${qs}`)).releases;
};

export const createRelease = async (release) =>
  (await authedFetch('/releases', { method: 'POST', body: JSON.stringify(release) })).release;

export const updateRelease = async (releaseId, release) =>
  (await authedFetch(`/releases/${encodeURIComponent(releaseId)}`, {
    method: 'PUT',
    body: JSON.stringify(release),
  })).release;

export const deleteRelease = (releaseId) =>
  authedFetch(`/releases/${encodeURIComponent(releaseId)}`, { method: 'DELETE' });
